import React from 'react'

import { DistanceUnit, SpeedUnit } from 'src/api/types/units'
import { getTemporalRange, ITemporalRange } from 'src/commons/temporalHelpers'
import { GranularityEnum, IFilters } from 'src/commons/types'
import { ILayer } from 'src/layout/MapLayerWrapper'

import {
  DEFAULT_MAX_DURATION,
  DEFAULT_MIN_DURATION,
  DEFAULT_MIN_DISTANCE,
  DEFAULT_MAX_DISTANCE,
  DEFAULT_MIN_SPEED,
  DEFAULT_MAX_SPEED,
} from '../Trips/constants'

export function getInitialFilters(
  layers?: ILayer[],
  getKpiRange?: () => ITemporalRange,
  withDuration = false,
  distanceUnit?: DistanceUnit,
  speedUnit?: SpeedUnit,
  day_of_week = false,
  closeMeansOfTransport = false
): IFilters {
  const initialFilters: IFilters = {
    granularity: GranularityEnum.day,
    providers: [],
    propulsions: [],
    vehicleTypes: [],
    range: getTemporalRange({ days: 7 }, true),
    endRange: { from: undefined, to: undefined },
    locationTypes: [],
    include_abnormals: false,
  }
  if (layers && layers.length > 0) {
    initialFilters.layer = layers.find((layer) => layer.permitLayer)?.id
  }
  if (getKpiRange) {
    initialFilters.range = getKpiRange()
  }
  if (withDuration) {
    initialFilters.duration = [DEFAULT_MIN_DURATION, DEFAULT_MAX_DURATION]
  }
  if (!!distanceUnit) {
    initialFilters.distance = [DEFAULT_MIN_DISTANCE[distanceUnit], DEFAULT_MAX_DISTANCE[distanceUnit]]
  }
  if (!!speedUnit) {
    initialFilters.speed = [DEFAULT_MIN_SPEED[speedUnit], DEFAULT_MAX_SPEED[speedUnit]]
  }
  if (day_of_week) {
    initialFilters.day_of_week = []
  }
  if (closeMeansOfTransport) {
    initialFilters.closeMeansOfTransport = []
  }
  return initialFilters
}

export const DashboardFiltersContext = React.createContext<IFilters>(getInitialFilters())
